import React from "react";
import css from "./Styles/color.module.scss";

export const enum Color
{
    Transparent,
    GoldenLemon,
    Orange,
    BlackDomina,
    White,
    SiteBackground,
    WarmMediumBackground,
    WarmLightGray,
    LightGray,
    WarmMediumGray,
    WarmBackground,
    Brown,
    Green,
    Gray,
    WarmGray,
    MutedLemon,
    MutedOrange,
    MutedGreen,
    MutedGray,
    GrayTextOnBlackDomina,
    MutedTan,
};

export const enum ColorType
{
    Background,
    Fill,
    Text,
}

const colorClassMap: Record<Color, string> = {
    [Color.Transparent]: "transparent",
    [Color.GoldenLemon]: "golden-lemon",
    [Color.Orange]: "orange",
    [Color.BlackDomina]: "black-domina",
    [Color.White]: "white",
    [Color.SiteBackground]: "site-background",
    [Color.WarmMediumBackground]: "warm-medium-background",
    [Color.WarmLightGray]: "warm-light-gray",
    [Color.LightGray]: "light-gray",
    [Color.WarmMediumGray]: "warm-medium-gray",
    [Color.WarmBackground]: "warm-background",
    [Color.Brown]: "brown",
    [Color.Green]: "green",
    [Color.Gray]: "gray",
    [Color.WarmGray]: "warm-gray",
    [Color.MutedLemon]: "muted-lemon",
    [Color.MutedOrange]: "muted-orange",
    [Color.MutedGreen]: "muted-green",
    [Color.MutedGray]: "muted-gray",
    [Color.GrayTextOnBlackDomina]: "gray-text-on-black-domina",
    [Color.MutedTan]: "muted-tan",
};

const colorTypeStylePropertyMap: Record<ColorType, "color" | "backgroundColor" | "fill"> = {
    [ColorType.Text]: "color",
    [ColorType.Background]: "backgroundColor",
    [ColorType.Fill]: "fill",
};

const colorTypeClassSuffixMap: Record<ColorType, string> = {
    [ColorType.Text]: "",
    [ColorType.Background]: "bg-",
    [ColorType.Fill]: "fill-",
};

export const colorClass = (color: Color | undefined, type: ColorType = ColorType.Text): string | undefined => color !== undefined ? css[`${colorTypeClassSuffixMap[type]}${colorClassMap[color]}`] : undefined;

export const colorProps = (color: Color | string | undefined, type: ColorType = ColorType.Text): { className?: string; style?: React.CSSProperties } =>
{
    if (color === undefined)
    {
        return {};
    }

    if (typeof color === "string")
    {
        color = color.trim().toLowerCase();
        if (color === "")
        {
            return {};
        }

        const colorEntry = Object.entries(colorClassMap).find(([_, v]) => v === color);
        if (colorEntry === undefined)
        {
            return { style: { [colorTypeStylePropertyMap[type]]: color } };
        }

        color = Number(colorEntry[0]) as Color;
    }

    return { className: colorClass(color, type) };
}